import { makeStyles, colors } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  new: {
    backgroundColor: colors.pink[100],
    color: colors.pink[800],
  },
  pending: {
    backgroundColor: colors.blue[100],
    color: colors.blue[800],
  },
  completed: {
    backgroundColor: colors.green[100],
    color: colors.green[800],
  },
  canceled: {
    backgroundColor: colors.red[100],
    color: colors.red[800],
  },
  waitingConfirmation: {
    backgroundColor: colors.purple[100],
    color: colors.purple[800],
  },
  awaitingCompanyReply: {
    backgroundColor: colors.teal[100],
    color: colors.teal[800],
  },
  awaitingReplyValidation: {
    backgroundColor: colors.cyan[100],
    color: colors.cyan[800],
  },
  replied: {
    backgroundColor: colors.indigo[100],
    color: colors.indigo[800],
  },
  reopen: {
    backgroundColor: colors.orange[100],
    color: colors.orange[800],
  },
  action: {
    padding: theme.spacing(1),
  },
}))

export default styles
